import React from 'react';
import { BaseModal } from './BaseModal';
export const Modal = ({ children, isOpen, handleClose, title, footer }) => (React.createElement(BaseModal, { isOpen: isOpen, handleClose: handleClose },
    React.createElement("div", { className: 'modal__content' },
        React.createElement("button", { className: "modal__close", onClick: handleClose, "aria-label": "Close Modal" },
            React.createElement("img", { alt: "", src: "/images/close-icon.svg" })),
        React.createElement("h3", { className: "modal__header" }, title),
        children,
        React.createElement("div", { className: 'modal__footer' }, footer))));
